import { LocalTrackerService } from './LocalTrackerService';
import { MixPanelTrackerService } from './MixPanelTrackerService';
import { PostHogTrackerService } from './PostHogTrackerService';
import { StackTrackerService } from './StackTrackerService';
import { TRACKER_DRIVER } from '~/app/enums/TrackerDriver';

export class TrackerFactory {
    static create(driver: string): TrackerService {
        switch (driver) {
            case TRACKER_DRIVER.MIXPANEL:
                return new MixPanelTrackerService();
            case TRACKER_DRIVER.POSTHOG:
                return new PostHogTrackerService();
            case TRACKER_DRIVER.LOCAL:
                return new LocalTrackerService();

            default:
                return new StackTrackerService(new PostHogTrackerService(), new MixPanelTrackerService());
        }
    }
}
